import { Divider, Grid, Typography } from "@material-ui/core";
import React from "react";
import Carousel from "react-material-ui-carousel";
import { useHistory } from "react-router-dom";
import FooterVideoPlace from "views/FooterVideoPlace/FooterVideoPlace";
import ResponsiveReactPlayer from "views/sidebar/ResponsiveReactPlayer/ResponsiveReactPlayer";

export default function Home() {
  const router = useHistory();
  const novidades = [
    { url: "https://www.youtube.com/watch?v=MDjZWOTh8x0", id: "0000000" },
    { url: "https://www.youtube.com/watch?v=BNd_80AR6Gc", id: "0000001" },
    { url: "https://www.youtube.com/watch?v=FA4Xhi2c6xs", id: "0000002" },
    { url: "https://www.youtube.com/watch?v=Q2KQFp-E3MI", id: "000003" },
  ];

  const categorias = [
    { label: "Eletrônicos", id: "0001", url: "eletronicos" },
    { label: "Móveis", id: "0002", url: "moveis" },
    { label: "Imóveis", id: "0003", url: "imoveis" },
  ];
  return (
    <div>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <ResponsiveReactPlayer
            url="https://www.youtube.com/watch?v=qA6KoyYFHTM"
            controls
            playing
            muted
            dividerUp
            dividerDown
            loop
            width="100%"
            height="60vh"
          />
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ paddingTop: "20px" }}
          >
            <Grid item xs={10}>
              <Typography variant="h5" color="secondary">
                Novidades na LoopTV!
              </Typography>
              <br />
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" justifyContent="center">
                {novidades.map((product) => {
                  return (
                    <Grid item sm={parseInt(12 / novidades.length)} xs={12}>
                      <ResponsiveReactPlayer
                        url={product.url}
                        playing
                        controls={false}
                        muted
                        dividerUp
                        dividerDown
                        loop
                        width="100%"
                        height="200px"
                        onClick={() => router.push("/produto/" + product.id)}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
            <Grid item xs={10} style={{ paddingTop: "40px" }}>
              <Typography variant="h5" color="secondary">
                Os mais assistidos:
              </Typography>
              <br />
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" justifyContent="center">
                {novidades.reverse().map((product) => {
                  return (
                    <Grid item sm={parseInt(12 / novidades.length)} xs={12}>
                      <ResponsiveReactPlayer
                        url={product.url}
                        playing
                        controls={false}
                        muted
                        dividerUp
                        dividerDown
                        loop
                        width="100%"
                        height="200px"
                        onClick={() => router.push("/produto/" + product.id)}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <FooterVideoPlace />
        </Grid>
      </Grid>
    </div>
  );
}
